import  { useRef } from "react";
import PropTypes from 'prop-types';
import "./print.css";
import moment from 'moment/min/moment-with-locales';
import 'moment/locale/es'; 
import Modal from "../modal";

moment.locale('es');

function PrintModal({ show, handleshow, Turno }) 
{
  const componentRef = useRef();
  const handleAceptar = () => 
    {
       handleshow(false);
    };

  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={''}>  
        <div className="flex flex-col w-[13.7rem] h-full" ref={componentRef}>
               <div className="flex flex-col w-full  text-gray-700 text-center items-center justify-center">
                   <div className="text-[0.565rem] font-semibold">{Turno?.NombreTerc}</div>
                   <div className="font-medium text-[0.45rem]">
                      Nit. {Turno?.NumeroNit} - {Turno?.Chequeo}
                   </div>
                   <div className="font-medium text-[0.45rem]">{Turno?.Direccion}</div>
                   <div className="font-medium text-[0.565rem]">{Turno?.NombreArea}</div>
                </div>
                <div className="flex w-full mt-8 mb-8 text-[2.2rem] font-semibold  text-gray-700 text-center items-center justify-center">
                   <span>{Turno?.Prefijo}</span> <span>{Turno?.Consecutivo}</span>
                </div>
               <div className="flex flex-col text-center items-center justify-center">
                  <span className="text-[0.85rem]">{Turno?.NombreServ}</span>
                  <span className="text-[0.56rem] ">
                     {Turno.FechaIng &&(moment(Turno.FechaIng ).format('DD MMMM YYYY HH:mm'))}
                  </span>
               </div>
               <div className="flex w-full gap-4 mt-6 justify-end">
                  <button onClick={handleAceptar} type="button">
                     Cerrar
                  </button>
               </div>
        </div>
      </Modal>
    </>
  );
}
PrintModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleshow: PropTypes.func.isRequired,
    Turno:PropTypes.object
  };
  
export default PrintModal;
